(function ($) {
  'use strict';

  var TRANSITION_TIMING = 250;
  var $mainNav = $('.nav-container');
  var $backToPrev = $('.cc--main-menu .back-to-prev');
  var $hamburger = $('.header-buttons .mobile-menu-trigger');
  var $searchButton = $('.header-buttons .search-trigger-button');
  var label = 'Open Site Navigation';
  var labelClose = 'Close Site Navigation';
  var $logo = $('.transparent-header .cc--branding-header a svg path');
  var $searchFormContainer = $('.cc--header .cc--search-form, .cc--header-school .cc--search-form');
  var $body = $('body');
  var $horNav = $('.cc--horizontal-strip');

  var openMenu = function () {
    if($horNav.length) {
      $('.cc--horizontal-strip').attr('aria-hidden', 'true');
      $('.cc--horizontal-strip').attr('tabindex', '-1');
    }
    $mainNav.css('style', 'block').fadeIn(TRANSITION_TIMING);
  };

  var closeMenu = function () {
    $mainNav.css('style', 'none').fadeOut(TRANSITION_TIMING);
    if($horNav.length) {
      $('.cc--horizontal-strip').attr('aria-hidden', 'false');
      $('.cc--horizontal-strip').removeAttr('tabindex');
    }
  };

  var initMainMenu = function () {
    // hamburger click/tap
    $hamburger.on('click', function (e) {
      e.preventDefault();
      $searchButton.removeClass('is-active');
      $searchButton.attr('aria-label', 'Open Site Search');
      $searchButton.attr('aria-expanded', 'false');
      closeSearch();

      if (!$(this).hasClass('is-active')) {
        openMenu();
        $(this).addClass('is-active');
        $('html').addClass('main-menu-open');
        $logo.removeClass('white');
        $body.removeClass('transparent-header');
      }
      else {
        closeMenu();
        $(this).removeClass('is-active');
        $('html').removeClass('main-menu-open');
        $logo.addClass('white');
      }

      if ($(this).hasClass('is-active')) {
        $hamburger.attr('aria-label', labelClose);
        $hamburger.attr('aria-expanded', 'true');
        $('#l--main-header').siblings().each(function (i, el) {
          el.inert = true;
        });
      }
      else {
        $hamburger.attr('aria-label', label);
        $hamburger.attr('aria-expanded', 'false');
        $('#l--main-header').siblings().each(function (i, el) {
          el.inert = false;
        });
      }

      // Windows OS scrollbar hack
      setTimeout(function () {
        if ($('.cc--header').hasClass('scroll-down')) {
          $('.cc--header').removeClass('scroll-down');
          $('.cc--header').addClass('scroll-up');
        }
      }, 300);
    });

    $backToPrev.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);

      if ($this.closest('ul').hasClass('m--menu')) {
        $this.closest('.cc--main-menu').removeClass('active');
      }

      $this.closest('li').children('.link-arrow-wrapper').find('button.opened').click();
    });

    var $menuItemBtn = $('.cc--main-menu .link-arrow-wrapper .expand');
    var $secondaryMenu = $('.cc--secondary-menu');
    var $primaryMenu = $('nav.mc--menu');
    var $suppMenu = $('.supplementary-menus');

    $menuItemBtn.on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $btnLabel = $(this).text().trim();
      var topOffset = $this.closest('.nav-container').css('top');
      var $liParent = $this.closest('li');
      var $ulParent = $this.closest('ul');
      var $navParent = $this.closest('nav');
      var $backgroundImage = $('.c--header-image .image-container');

      // Close menu if you clicked on the same opened button
      if ($liParent.hasClass('is-open')) {
        $liParent.removeClass('is-open');
        $this.attr('aria-expanded', 'false');
        $this.removeClass('opened').attr('aria-label', 'Display Sub Menu for ' + $btnLabel);
        $liParent.children('.submenus-wrapper').fadeOut(150);
        $liParent.children('.submenus-wrapper').removeClass('active-submenu');
        // Remove class background color if you click on first level menu
        if ($ulParent.hasClass('m--menu')) {
          $backgroundImage.removeClass('background-color');
          $suppMenu.removeClass('hide');
        }
      } else {
        // Check if there is any other already opened menu item and close it
        if ($ulParent.children('li.is-open')) {
          $ulParent.children('li.is-open').children('.link-arrow-wrapper').find('button').click();
        }

        // Close secondary menu if opened
        if (
          $navParent.hasClass('mc--menu') &&
          $secondaryMenu.find('button.opened')
        ) {
          $secondaryMenu.find('button.opened').click();
        } else if ($primaryMenu.find('button.opened')) {
          // Close primary menu if opened
          $primaryMenu.find('button.opened').click();
        }

        // Simply open submenu on click
        $liParent.addClass('is-open');
        $this.attr('aria-expanded', 'true');
        $this.addClass('opened').attr('aria-label', 'Close Sub Menu for ' + $btnLabel);
        $liParent.children('.submenus-wrapper').fadeIn(TRANSITION_TIMING);
        $liParent.parents('.submenus-wrapper').removeClass('active-submenu');
        $liParent.children('.submenus-wrapper').addClass('active-submenu');
        if ($ulParent.hasClass('m--menu')) {
          $backgroundImage.addClass('background-color');
        }
        $this.closest('.cc--main-menu').addClass('active');
        $this.closest('.cc--main-menu').css('bottom', topOffset);
        $suppMenu.addClass('hide');
      }
    });
  };

  var closeSearch = function () {
    $searchFormContainer.removeClass('is-open').attr('aria-hidden', 'true').fadeOut(100);
  };

  window.DP.behaviors.mainMenu = {
    attach: function (context) {
      $(context).find('.cc--main-menu').once('mainMenu').each(function () {
        initMainMenu.apply();
      });
    },
  };
})(jQuery);
